"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Api_1 = __importDefault(require("./Api"));
const array_prototype_flatmap_1 = __importDefault(require("array.prototype.flatmap"));
// A function is prefered over a class in this situation to
// avoid having to declare the entire object in the constructor
function CustomModule(baseRoute, logger, description) {
    return description;
}
exports.CustomModule = CustomModule;
function Module(baseRoute, logger, templateFunctions) {
    return {
        namespaced: true,
        state: {
            queries: {},
            data: {},
        },
        mutations: {
            setLoading(state, { queryRoute, value }) {
                let lastUpdated = !value ? Date.now() : undefined;
                state.queries = Object.assign(Object.assign({}, state.queries), { [queryRoute]: Object.assign(Object.assign({}, state.queries[queryRoute]), { loading: value, lastUpdated }) });
            },
            setData(state, { queryRoute, data, template, pageInfo, queryInfo, res }) {
                let temp = data.result || data;
                let formattedData = template[1](temp, templateFunctions, res);
                if (!formattedData.id) {
                    throw Error('Data does not contain an id field! Template lambda must return at minimum an id field', formattedData);
                }
                state.data = Object.assign(Object.assign({}, state.data), { [template[0] + formattedData.id]: formattedData });
                state.queries = Object.assign(Object.assign({}, state.queries), { [queryRoute]: Object.assign(Object.assign({}, state.queries[queryRoute]), { ids: formattedData.id, pageInfo,
                        queryInfo }) });
            },
            setDataWithoutQuery(state, { data, template, promiseResolver }) {
                let temp = data.result || data;
                let formattedData = template[1](temp, templateFunctions);
                if (formattedData.id) {
                    state.data = Object.assign(Object.assign({}, state.data), { [template[0] + formattedData.id]: formattedData });
                }
                return promiseResolver(formattedData);
            },
            setDataArray(state, { queryRoute, data, template, pageInfo, queryInfo, res }) {
                logger.log('Set data array', data);
                let temp = data.result || data;
                let formattedData = temp
                    .map(it => it.result || it)
                    .map(it => template[1](it, templateFunctions, res));
                if (formattedData.length > 0 && !formattedData[0].id) {
                    throw Error('Data[0] does not contain an id field! Template lambda must return at minimun an id field', formattedData);
                }
                formattedData.forEach(it => (state.data = Object.assign(Object.assign({}, state.data), { [template[0] + it.id]: it })));
                state.queries = Object.assign(Object.assign({}, state.queries), { [queryRoute]: Object.assign(Object.assign({}, state.queries[queryRoute]), { ids: formattedData.map(it => it.id), pageInfo,
                        queryInfo }) });
            },
            setDataArrayWithoutQuery(state, { data, template, promiseResolver }) {
                let temp = data.result || data;
                let formattedData = temp
                    .map(it => it.result || it)
                    .map(it => template[1](it, templateFunctions));
                if (formattedData[0].id) {
                    formattedData.forEach(it => (state.data = Object.assign(Object.assign({}, state.data), { [template[0] + it.id]: it })));
                }
                return promiseResolver(formattedData);
            },
            setError(state, { queryRoute, value }) {
                logger.log('committing setError on route', queryRoute, 'with value', value === undefined
                    ? 'Resetting error because request returned successfully'
                    : value);
                state.queries = Object.assign(Object.assign({}, state.queries), { [queryRoute]: Object.assign(Object.assign({}, state.queries[queryRoute]), { error: value }) });
            },
            newQuery(state, { queryRoute, nextPage }) {
                logger.log('committed newQuery with route', queryRoute);
                state.queries = Object.assign(Object.assign({}, state.queries), { [queryRoute]: {
                        ids: [],
                        error: null,
                        loading: false,
                        lastUpdated: null,
                        pageInfo: null,
                        queryInfo: null,
                    } });
            },
            clearData(state) {
                //This function should only be called by clear!
                state.data = {};
            },
            clearQueries(state) {
                //This function should only be called by clear!
                state.queries = {};
            },
        },
        getters: {
            get: (state // From vuex
            ) => (store, baseRoute, template, authorize, // From interface
            baseURL, staticQuery, entry, methodObject) => (_a, page = 1) => {
                var { forceUpdate, authorize: shouldAuthorize, baseURL: thisBaseURL, reactive = false, // From RestX caller
                formData } = _a, query = __rest(_a, ["forceUpdate", "authorize", "baseURL", "reactive", "formData"]);
                // From user
                let queryBase = Object.assign(Object.assign({}, query), { page });
                let storeNamespace = baseRoute.split('/')[0];
                let queryRoute = baseRoute +
                    JSON.stringify(queryBase, Object.keys(queryBase).sort());
                let commitLoading = value => store.commit(storeNamespace + '/setLoading', {
                    queryRoute,
                    value,
                });
                let queryFromStore = state.queries[queryRoute];
                const outputFunc = () => {
                    let queryFromStore = state.queries[queryRoute];
                    return Object.assign(Object.assign({}, queryFromStore), { data: queryFromStore.ids instanceof Array
                            ? queryFromStore.ids.map(id => state.data[template[0] + id])
                            : state.data[template[0] + queryFromStore.ids], queryRoute });
                };
                logger.log('Getting query from route ' + queryRoute, queryFromStore);
                if (!queryFromStore ||
                    ((forceUpdate || !queryFromStore.lastUpdated) &&
                        !queryFromStore.loading)) {
                    if (forceUpdate)
                        logger.log(baseRoute, 'is forceupdating');
                    if (!queryFromStore) {
                        logger.log('Creating new query', queryRoute);
                        store.commit(storeNamespace + '/newQuery', {
                            queryRoute,
                        });
                    }
                    let commitData = (data, pageInfo, queryInfo, res) => {
                        if ( /* !data || */data === {} /*  || data === [] */)
                            return;
                        logger.log('Committing data', data);
                        store.commit((data.result || data || {}) instanceof Array
                            ? storeNamespace + '/setDataArray'
                            : storeNamespace + '/setData', {
                            queryRoute,
                            template,
                            data,
                            pageInfo,
                            queryInfo,
                            res,
                        });
                    };
                    let commitError = value => {
                        logger.log('Error occured', value);
                        store.commit(storeNamespace + '/setError', {
                            queryRoute,
                            value: value == undefined
                                ? undefined
                                : value.data || value,
                        });
                    };
                    let url = getUrl(baseRoute, Object.assign(Object.assign({}, staticQuery), query));
                    commitLoading(true);
                    const apiQuery = Api_1.default('GET', url, {}, null, shouldAuthorize instanceof Boolean
                        ? shouldAuthorize
                        : authorize, thisBaseURL instanceof String ? thisBaseURL : baseURL, formData)(templateFunctions)
                        .then(res => {
                        logger.log('Got data', res, 'from baseRoute', baseRoute, 'with entry', entry);
                        logger.log(res, 'template', template);
                        commitLoading(false);
                        commitError(undefined);
                        commitData(entry(res), template[2]
                            ? template[2]['pageInfo'] &&
                                template[2]['pageInfo'](res)
                            : {}, methodObject['queryInfo']
                            ? methodObject['queryInfo'](res, queryRoute)
                            : {}, res);
                        if (methodObject['action'])
                            methodObject['action'](res, queryRoute);
                    })
                        .catch(err => {
                        logger.log('Got error', err, 'from baseRoute', baseRoute);
                        commitLoading(false);
                        commitError(err);
                        return Promise.reject(err);
                    });
                    if (!reactive) {
                        return apiQuery.then(outputFunc);
                    }
                }
                if (!reactive) {
                    return new Promise((res) => __awaiter(this, void 0, void 0, function* () {
                        while (outputFunc().loading) {
                            yield new Promise(res => {
                                setTimeout(() => {
                                    res();
                                }, 100);
                            });
                        }
                        return res(outputFunc());
                    }));
                }
                return outputFunc();
            },
        },
        actions: {
            clear({ commit }, baseRoute) {
                return __awaiter(this, void 0, void 0, function* () {
                    commit('clearData');
                    commit('clearQueries');
                });
            },
            genericMethod({ commit, state }, payload) {
                return __awaiter(this, void 0, void 0, function* () {
                    // TODO: genericMethod doesn't use staticQuery yet
                    if (!payload.method ||
                        !payload.url ||
                        !(payload.body && payload.template)) {
                        throw Error('action is missing essential payload items either method, url or template if body is supplied');
                    }
                    let commitData = (data, pageInfo) => new Promise(res => {
                        const d = payload.store.commit(data.result instanceof Array
                            ? payload.baseRoute.split('/')[0] +
                                '/setDataArrayWithoutQuery'
                            : payload.baseRoute.split('/')[0] +
                                '/setDataWithoutQuery', {
                            template: payload.template,
                            data,
                            promiseResolver: res,
                            pageInfo,
                        });
                    });
                    logger.log('Executing query', payload.method, payload.url, payload.query, payload.body, payload.authorize);
                    return Api_1.default(payload.method, payload.url, payload.query, payload.body, payload.authorize, payload.baseURL, payload.formData)(templateFunctions).then(res => {
                        return commitData(payload.entry(res), payload.template[2]
                            ? payload.template[2]['pageInfo'] &&
                                payload.template[2]['pageInfo'](res)
                            : {});
                    });
                });
            },
        },
    };
}
exports.default = Module;
function getUrl(baseRoute, query) {
    return (baseRoute +=
        '?' +
            array_prototype_flatmap_1.default(Object.entries(query)
                .filter(([k, v]) => (v instanceof Array ? v.length > 0 : true))
                .sort(), ([k, v]) => v instanceof Array
                ? v.sort().map(value => `${k}=${queryEncode(value)}`)
                : `${k}=${queryEncode(v)}`)
                .join('&'));
}
function queryEncode(string) {
    return encodeURIComponent(string);
}
